module.exports = __webpack_public_path__ + "static/media/iconW.e25bb911.svg";